import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";

const Reports = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/reports" || location.pathname === "/reports/") {
      navigate("/not-found");
    }
  }, [location, navigate]);
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default Reports;
